export default __webpack_public_path__ + "static/media/KAIRA_Q10.972bf4dc.jpg";